import { BaseApi } from "./BaseApi";
import { PagedMessageResponse } from "../types/PagedMessageResponse";
import globalMU from "globalMU";
import { AxiosRequestConfig } from "axios";
import { ICidade } from "app/types/ICidade";
import { IEndereco } from "app/types/IEndereco";
import { Bairro } from "app/types/NovoEndereco";
import { SenhaModal } from "app/types/cliente/RespostaCredito";
import { DadosEnviarEmail } from "app/types/modalImprimir/ModalEnviarEmail";
import { CepPorEndereco } from "app/types/CepPorEndereco";
import { PesquisaCep } from "app/types/PesquisaCep";
import { DadosEnviarWhatsapp } from "app/types/modalImprimir/DadosEnviarWhatsapp";
import { EnviarWhatsappOutput } from "app/types/Whatsapp/EnviarWhatsappOutput";
import { AnexosEnviarWhatsapp, DadosEnviarWhatsappMuWhatsappApi } from "app/types/modalImprimir/DadosEnviarWhatsappMuWhatsappApi";



export class ComumApi extends BaseApi {
    url(path): string {
        return `${globalMU.restUrl()}/api/comum/${path}`;
    }
    urlApiEnterprise(path: string): string {
        return `${globalMU.enterpriseUrl()}/api/${path}`;
    }

    async obterEnderecoAuthServer(): Promise<string> {
        return (await this.api.get(`/Comum/ObterEnderecoAuthServer`)).data;
    }

    async ValidarCpfCnpj(numeroCpfCnpj: string): Promise<string> {
        return (
            await this.api.post(`/Comum/ValidarCpfCnpj`, {
                numeroCpfCnpj,
            })
        ).data;
    }

    async ObterTIpoPessoa(
        numeroCpfCnpj: string,
        validarCnpjCpfCadastrado: boolean
    ): Promise<string> {
        return (
            await this.api.get(`/Comum/ObterTIpoPessoa`, {
                params: {
                    numeroCpfCnpj,
                    validarCnpjCpfCadastrado,
                },
            })
        ).data;
    }

    async obterEnderecoPorCep(cep: string): Promise<IEndereco> {
        const resposta = await this.api.post(`/Comum/ObterEnderecoPorCep`, { cep });
        return resposta.data;
    }

    async obterParametroChaveMovimentacao(): Promise<string> {
        const resposta = await this.api.get(`/Comum/ObterParametroChaveMovimentacao`);
        return resposta.data;
    }

    async listarCidadesPorEstado(codigoEstado: number): Promise<ICidade[]> {
        const resposta = await this.api.post(`/Comum/ListarCidadesPorEstado`, {
            codigoEstado,
        });
        return resposta.data;
    }

    async listarBairrosPreCadastrados(bairro: string): Promise<Bairro[]> {
        const resposta = await this.api.post(`/Comum/ListarBairrosPreCadastrados`, {
            bairro,
        }, {
            mostrarMensagensUsuario: false
        } as AxiosRequestConfig & any);
        return resposta.data;
    }

    async obterCepPorEndereco(pesquisaCEP: PesquisaCep): Promise<PagedMessageResponse<CepPorEndereco>> {
        return (await this.api.post(`/Comum/ObterCepPorEndereco`, { pesquisaCEP })
        ).data;
    }

    async PermissaoSenhaVenda(permissoes: string[]): Promise<SenhaModal> {
        const { data } = await this.api.post(`/Comum/PermissaoSenhaVenda`, { permissoes })
        return data
    }

    async excluirControleDeExclusividade(actionParameter: string, nomeTabela: string): Promise<SenhaModal> {
        const { data } = await this.api.post(`/Comum/ExcluirControleDeExclusividade`, { actionParameter, nomeTabela })
        return data
    }

    async ValidarPermissaoSenhaVenda(codigoSenha: string, permissoes: string[]): Promise<string> {
        const resposta = await this.api.post(`/Comum/ValidarPermissaoSenhaVenda`, { codigoSenha, permissoes })
        return resposta.data
    }

    async EnviarEmail(DadosEnviarEmail: DadosEnviarEmail): Promise<any> {
        const resposta = await this.api.post(this.url(`email/enviar`), { ...DadosEnviarEmail }, { withCredentials: true, headers: { Accept: "*/*" } });
        return resposta.data;
    }

    async EnviarWhatsapp(DadosEnviarWhatsapp: DadosEnviarWhatsappMuWhatsappApi): Promise<EnviarWhatsappOutput> {
        const token = globalMU.token();

        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            },
        };

        const resposta = await this.Enterprise.post(this.urlApiEnterprise(`eventos/whatsapp`), { ...DadosEnviarWhatsapp }, config);
        return resposta.data;
    }

    async ObterAnexos(DadosEnviarWhatsapp: DadosEnviarWhatsapp): Promise<AnexosEnviarWhatsapp[]> {
        const resposta = await this.api.post(this.url(`email/obterAnexos`), { ...DadosEnviarWhatsapp }, { withCredentials: true, headers: { Accept: "*/*" } });
        return resposta.data;
    }
    private cacheVersaoEnterprise: Record<string, string> = {};

    async versaoApiEnterprise(): Promise<string> {
        const cacheKey = 'versaoEnterprise';
        if (this.cacheVersaoEnterprise[cacheKey]) {
            return this.cacheVersaoEnterprise[cacheKey];
        }


        const token = globalMU.token();

        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            },
        };

        const resposta = await this.Enterprise.get(
            this.urlApiEnterprise("comum/versaoenterprise"),
            config
        );
        this.cacheVersaoEnterprise[cacheKey] = resposta.data;
        return resposta.data;
    }
}
